
















import { Component, Mixins } from 'vue-property-decorator';
import { Office, MapSettings, MapMarker } from 'client-website-ts-library/types';
import { API, Config } from 'client-website-ts-library/services';
import { Map } from 'client-website-ts-library/components';
import { View } from 'client-website-ts-library/plugins';
import Form from '@/components/Forms/Form.vue';

@Component({
  components: {
    Map,
    Form,
  },
})
export default class ContactUs extends Mixins(View) {
  private office: Office | null = null;

  private mapSettings: MapSettings | null = null;

  mounted() {
    const markers = [];
    markers.push(
      new MapMarker({
        Title: 'South Office',
        Coordinate: {
          Lat: -17.0917093,
          Lon: 145.7840229,
        },
      }),
    );

    this.mapSettings = new MapSettings({
      Markers: markers,
      Interactive: true,
    });

    // ADDRESS DONT WORK NEED TO STORE LAT AND LONG FOR OFFICE
    /*
    API.Franchises.GetOffices(Config.Website.Settings!.WebsiteId).then((offices) => {
      const markers = [];

      for (let index = 0; index < offices.length; index += 1) {
        markers.push(
          new MapMarker({
            Title: `${offices[index].OfficeName}`,
            Address: `${offices[index].AddressLine1} ${offices[index].AddressLine2}`,
          }),
        );
      }

      this.mapSettings = new MapSettings({
        Markers: markers,
      });

      console.debug(this.mapSettings);
    });
    */
  }
}
